export default defineNuxtPlugin(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/pwa_sw.js')
      .then((reg) => {
        console.log('Service Worker registered success:', reg.scope);
      })
      .catch((err) => {
        console.error('Service Worker register fail Error:', err);
      });
  }
});
